export const blackListDomain = [
  "@gmail.com",
  "@yahoo.com",
  "@hotmail.com",
  "@outlook.com",
  "@icloud.com",
  "@live.com",
  "@aol.com",
  "@msn.com",
  "@mail.com",
  "@protonmail.com",
  "@yandex.com",
  "@zoho.com",
  "@gmx.com",
  "@fastmail.com",
  "@tutanota.com",
  "@hushmail.com",
  "@mail.ru",
  "@inbox.com",
  "@webmail.com",
  "@rocketmail.com",
  "@lycos.com",
  "@rediffmail.com",
  "@mailinator.com",
  "@temp-mail.org",
  "@10minutemail.com",
  "@guerrillamail.com",
  "@discard.email",
  "@getnada.com",
  "@maildrop.cc",
  "@temp-mail.com",
  "@sharklasers.com",
  "@yopmail.com",
  "@mytemp.email",
  "@tempinbox.com",
  "@fakeinbox.com",
  "@mailcatch.com",
  "@spamgourmet.com",
  "@spambox.us",
  "@spambox.me",
  "@spambog.com",
  "@spamex.com",
  "@mailnesia.com",
  "@mailinator.com",
  "@mailinator.net",
  "@mailinator.org",
  "@mailinator.co.uk",
  "@mailinator.com.br",
  "@mailinator.us",
  "@mailinator.eu",
  "@mailinator.info",
  "@mailinator.pro",
  "@mailinator.xyz",
  "@mailinator.cc",
  "@mailinator.asia",
  "@mailinator.mobi",
  "@mailinator.tel",
  "@mailinator.name",
  "@mailinator.jobs",
  "@mailinator.ws",
  "@mailinator.me",
  "@mailinator.tv",
  "@mailinator.cc",
  "@mailinator.co",
  "@mailinator.com.au",
  "@mailinator.com.mx",
  "@mailinator.com.tr",
  "@mailinator.com.sg",
  "@mailinator.com.hk",
  "@mailinator.com.ph",
  "@mailinator.com.vn",
  "@mailinator.com.co",
  "@mailinator.com.co.id",
  "@mailinator.com.co.kr",
];
